import { render, staticRenderFns } from "./MysteryBoxes.vue?vue&type=template&id=5bba696b&scoped=true&"
import script from "./MysteryBoxes.vue?vue&type=script&lang=js&"
export * from "./MysteryBoxes.vue?vue&type=script&lang=js&"
import style0 from "./MysteryBoxes.vue?vue&type=style&index=0&id=5bba696b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bba696b",
  null
  
)

export default component.exports